module.exports = __webpack_public_path__ + "static/img/3805_phase_function_Paper_Points.08e6bc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3805_phase_function_Paper_Points.png
// module id = W8Cd
// module chunks = 0